<template>
	<div>
        <div class="row">
            <el-card class="pb-4 pt-3" shadow="always" :body-style="{ padding: '0px'}" style="width:100%;">
             
                <div class="row">
                    <div class="col-md-2">
                        <el-button size="mini" @click="$router.push('/performance-report/fuel-retail')"><i class="fa fa-angle-left"></i></el-button>
                    </div>
                    <div class="col-md-8"><h4 class="text-center">SALES VOLUME & LOSSES</h4></div>
                    <div class="col-md-2 text-right">
                        <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                        <el-button size="mini" @click="$router.push('/performance-report/profit-laba')"><i class="fa fa-angle-right"></i></el-button>
                    </div>
                </div>

                <div class="col-md-12">
                    <el-tabs v-model="activeName" @tab-click="handleTabClick">
                        <el-tab-pane name="first">
                            <span slot="label"><i class="fa fa-gas-pump"></i>&nbsp;&nbsp;<b>SALES VOLUME</b></span>
                            <div>
                                <SalesVolumeTabContent/>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="second">
                            <span slot="label"><i class="fa fa-gas-pump"></i>&nbsp;&nbsp;<b>LOSSES BY PRODUCT</b></span>
                            <div>
                                <LossesByProductTabContent/>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>

            </el-card>
    </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import SalesVolumeTabContent from '@/views/pages/LaporanKinerja/SalesAndLosses/SalesVolumeTabContent.vue'
import LossesByProductTabContent from '@/views/pages/LaporanKinerja/SalesAndLosses/LossesByProductTabContent.vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
        SalesVolumeTabContent,
        LossesByProductTabContent,
		//ReportParamSelect,
	},

	data() {
		return {
            activeName: 'first',
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');

        if(!this.isLocalPeriodSet()) {
            console.log('period is not set')
            //this.$router.push('/performance-report/')
            //this.$route.go('/performance-report/')
        } else {
            console.log('period set')
        }
    },
    methods: {
        handleTabClick(tab, event) {
        console.log(tab, event);
      }
    },
}
</script>